import httpClient from '../httpClient';
import { API_CONTACT_MESSAGES, API_DEMO_REQUESTS } from '../config';

export const websiteLeadService = {
  submitContact({ name, email, message }) {
    return httpClient.post(API_CONTACT_MESSAGES, { name, email, message });
  },

  submitDemo({ hospital_name, name, work_email, where_you_would_start }) {
    return httpClient.post(API_DEMO_REQUESTS, {
      hospital_name,
      name,
      work_email,
      where_you_would_start,
    });
  },
};
